"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const AllPurchaseBill = () => {
  const [bills, setBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  /* ================= FETCH PURCHASE BILLS ================= */
  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        "https://logicx.premierlam.com/api/get-pixel-purchase-bills",
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
          },
        }
      );
      setBills(res.data.data || []);
    } catch (err) {
      toast.error("Failed to fetch purchase bills");
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= FILTER ================= */
  const filteredBills = bills.filter((b) =>
    b.invoice_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    b.merchant_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /* ================= DATE FORMAT ================= */
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="min-h-screen bg-gray-50 p-2">
        <div className="max-w-7xl mx-auto">

          {/* HEADER */}
          <div className="flex justify-between items-start mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900 mb-1">
                Purchase Bills
              </h1>
              <p className="text-gray-500">Manage purchase bills</p>
            </div>
             <Link
                            to="/add-purchase-bill"
                            className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
                        >
                            + Add Purchase Bill
                        </Link>
          </div>

          {/* TABLE CONTAINER */}
          <div className="bg-white rounded-lg shadow-sm border p-6">

            {/* SEARCH */}
            <input
              type="text"
              placeholder="Search by invoice or merchant"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="mb-4 px-4 py-2 border rounded-lg w-64"
            />

            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="text-center py-6">Loading...</div>
              ) : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b text-gray-600 whitespace-nowrap">
                      <th className="py-3 px-4 text-left">Invoice ID</th>
                      <th className="py-3 px-4 text-left">Date</th>
                      <th className="py-3 px-4 text-left">Invoice Month</th>
                      <th className="py-3 px-4 text-left">Invoice Year</th>
                      <th className="py-3 px-4 text-left">Merchant Name</th>
                      <th className="py-3 px-4 text-left">Merchant Email</th>
                      <th className="py-3 px-4 text-left">Merchant Phone</th>
                      <th className="py-3 px-4 text-left">Merchant Address</th>
                      <th className="py-3 px-4 text-left">Merchant State</th>
                      <th className="py-3 px-4 text-left">Place Of Supply</th>
                      <th className="py-3 px-4 text-left">GST Amount</th>
                      <th className="py-3 px-4 text-left">Net Amount</th>
                      <th className="py-3 px-4 text-left">Total Amount</th>
                      <th className="py-3 px-4 text-left">No Of Items</th>
                      <th className="py-3 px-4 text-left">Invoice Link</th>
                      <th className="py-3 px-4 text-left">Added By</th>
                      <th className="py-3 px-4 text-left">Created At</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredBills.map((b) => (
                      <tr
                        key={b.id}
                        className="border-b hover:bg-gray-50 whitespace-nowrap"
                      >
                        <td className="py-3 px-4">{b.invoice_id}</td>
                        <td className="py-3 px-4">{b.date}</td>
                        <td className="py-3 px-4">{b.invoice_month}</td>
                        <td className="py-3 px-4">{b.invoice_year}</td>
                        <td className="py-3 px-4">{b.merchant_name}</td>
                        <td className="py-3 px-4">{b.merchant_email || "-"}</td>
                        <td className="py-3 px-4">{b.merchant_phone}</td>
                        <td className="py-3 px-4">{b.merchant_address}</td>
                        <td className="py-3 px-4">{b.merchant_state}</td>
                        <td className="py-3 px-4">{b.place_of_supply}</td>
                        <td className="py-3 px-4">{b.gst_amount}</td>
                        <td className="py-3 px-4">{b.net_amount}</td>
                        <td className="py-3 px-4">{b.total_amount}</td>
                        <td className="py-3 px-4">{b.no_of_items}</td>
                        <td className="py-3 px-4">
                          {b.invoice_link ? (
                            <a
                              href={b.invoice_link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 underline"
                            >
                              {b.invoice_link}
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="py-3 px-4">{b.added_by}</td>
                        <td className="py-3 px-4">
                          {formatDate(b.created_at)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default AllPurchaseBill;


// "use client";

// import { useEffect, useState } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const AllPurchaseBill = () => {
//   const [bills, setBills] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     fetchBills();
//   }, []);

//   const fetchBills = async () => {
//     try {
//       setIsLoading(true);
//       const res = await axios.get(
//         "https://logicx.premierlam.com/api/get-pixel-purchase-bills",
//         { headers: { authorization: localStorage.getItem("accessToken") } }
//       );
//       setBills(res.data.data || []);
//     } catch {
//       toast.error("Failed to fetch purchase bills");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="min-h-screen bg-gray-50 p-4">
//         <div className="max-w-7xl mx-auto">

//           {/* HEADER */}
//           <div className="flex justify-between mb-6">
//             <div>
//               <h1 className="text-2xl font-semibold text-gray-900">
//                 Purchase Bills
//               </h1>
//               <p className="text-gray-500">All purchase bills</p>
//             </div>

//             <Link
//               to="/add-purchase-bill"
//               className="bg-orange-500 text-white px-4 py-2 rounded-lg"
//             >
//               + Add Purchase Bill
//             </Link>
//           </div>

//           {/* TABLE */}
//           <div className="bg-white rounded-lg border p-6 overflow-x-auto">
//             {isLoading ? (
//               <div className="text-center py-6">Loading...</div>
//             ) : (
//               <table className="w-full text-sm">
//                 <thead>
//                   <tr className="border-b text-gray-600">
//                     <th className="py-2 px-3">Invoice ID</th>
//                     <th className="py-2 px-3">Date</th>
//                     <th className="py-2 px-3">Merchant</th>
//                     <th className="py-2 px-3">GST</th>
//                     <th className="py-2 px-3">Net</th>
//                     <th className="py-2 px-3">Total</th>
//                     <th className="py-2 px-3">Items</th>
//                     <th className="py-2 px-3">Created At</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {bills.map((b) => (
//                     <tr key={b.id} className="border-b hover:bg-gray-50">
//                       <td className="py-2 px-3">{b.invoice_id}</td>
//                       <td className="py-2 px-3 whitespace-nowrap">{b.date}</td>
//                       <td className="py-2 px-3">{b.merchant_name}</td>
//                       <td className="py-2 px-3">{b.gst_amount}</td>
//                       <td className="py-2 px-3">{b.net_amount}</td>
//                       <td className="py-2 px-3">{b.total_amount}</td>
//                       <td className="py-2 px-3">{b.no_of_items}</td>
//                       <td className="py-2 px-3 whitespace-nowrap">
//                         {new Date(b.created_at).toLocaleDateString("en-GB")}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )}
//           </div>

//         </div>
//       </div>
//     </>
//   );
// };

// export default AllPurchaseBill;
